// extracted by mini-css-extract-plugin
module.exports = {"byline":"IntroOutroCard__byline--2cVTs","authorPrefix":"IntroOutroCard__authorPrefix--3Tdib","bounce":"IntroOutroCard__bounce--2ldzV"};